import {guardTicketEmailClose} from '../features/email-inbox/ticket-close-guard';
import {positionPopupCloseButton} from './popup-close-button';
import {getTranslation} from "../helpers/helpers";
import "@fancyapps/ui/dist/fancybox.css";
import {Fancybox} from "@fancyapps/ui";

import {schedulePopupRefresh, registerPopupReload} from './popup-refresh';

Fancybox.defaults.Hash = false;
Fancybox.defaults.on = {
    ...Fancybox.defaults.on,
    done: schedulePopupRefresh,
    destroy: schedulePopupRefresh,
};

const fancyboxRootAttribute = 'data-fancybox-root';

export class FancyboxClass {
    constructor() {
        this.initFancybox();
    }

    initFancybox() {
        Fancybox.bind("[data-fancybox]", {
            infinite: false,
            hash: false,
            type: 'inline',
            toolbar: false,
            touch: {
                vertical: false,
                momentum: false
            },
            dragToClose: false,
            autoFocus: false,
            trapFocus: false,
            on: {
                done: (_fancybox, slide) => { positionPopupCloseButton(slide.$content); schedulePopupRefresh(); },
                // The customer popup's email reader is a native dialog that owns
                // Escape: without this Fancybox closes the popup behind it, and a
                // reply being written goes with it.
                keydown: function (fancybox) {
                    if (fancybox.$container.querySelector('.ng-email-ticket-dialog[open]')) return false;
                },
                click: (fancybox, event) => {
                    if (event.composedPath().some((node) => node instanceof Element && node.matches('.ng-email-ticket-dialog'))) return false;
                    // Clear selection when clicking backdrop or close button
                    if (event.target.classList.contains('fancybox__backdrop') || 
                        event.target.classList.contains('fancybox__button--close') ||
                        event.target.closest('.fancybox__button--close')) {
                        window.getSelection().removeAllRanges();
                    }
                }
            }
        });

        Fancybox.bind("[data-fancybox-iframe]", {
            infinite: false,
            hash: false,
            type: 'iframe',
            toolbar: false,
            touch: {
                vertical: false,
                momentum: false
            },
            dragToClose: false,
            autoFocus: false,
            trapFocus: false,
            on: {
                click: (fancybox, event) => {
                    if (event.target.classList.contains('fancybox__backdrop') || 
                        event.target.classList.contains('fancybox__button--close') ||
                        event.target.closest('.fancybox__button--close')) {
                        window.getSelection().removeAllRanges();
                    }
                }
            }
        });

        Fancybox.bind("[data-support-ticket-fancybox]", {
            infinite: false,
            hash: false,
            type: 'inline',
            toolbar: false,
            touch: {
                vertical: false,
                momentum: false
            },
            dragToClose: false,
            autoFocus: false,
            trapFocus: false,
            on: {
                ready: function () {
                    window.fieldsChanged = 0;
                },
                done: (_fancybox, slide) => { positionPopupCloseButton(slide.$content); schedulePopupRefresh(); },
                keydown: function (fancybox) {
                    // Native email dialogs own Escape and keyboard navigation.
                    if (fancybox.$container.querySelector('.ng-email-ticket-dialog[open]')) return false;
                },
                shouldClose: function (fancybox) {
                    if (!guardTicketEmailClose(fancybox)) return false;
                    if (window.fieldsChanged > 0 && window.formSaved !== true) {
                        return confirm(getTranslation('unsaved_popup_confirm'));
                    }
                },
                click: (fancybox, event) => {
                    // A rerender may detach the clicked email action before the event bubbles.
                    if (event.composedPath().some((node) => node instanceof Element && node.matches('.ng-email-ticket-dialog'))) return false;
                    if (event.target.classList.contains('fancybox__backdrop') || 
                        event.target.classList.contains('fancybox__button--close') ||
                        event.target.closest('.fancybox__button--close')) {
                        window.getSelection().removeAllRanges();
                    }
                }
            }
        });

        Fancybox.bind("[data-booking-fancybox]", {
            infinite: false,
            hash: false,
            type: 'inline',
            toolbar: false,
            touch: {
                vertical: false,
                momentum: false
            },
            dragToClose: false,
            autoFocus: false,
            trapFocus: false,
            on: {
                click: (fancybox, event) => {
                    if (event.target.classList.contains('fancybox__backdrop') || 
                        event.target.classList.contains('fancybox__button--close') ||
                        event.target.closest('.fancybox__button--close')) {
                        window.getSelection().removeAllRanges();
                    }
                }
            }
        });

        Fancybox.bind("[data-cloud-data-fancybox]", {
            infinite: false,
            hash: false,
            type: 'inline',
            toolbar: false,
            touch: {
                vertical: false,
                momentum: false
            },
            dragToClose: false,
            autoFocus: false,
            trapFocus: false,
            on: {
                click: (fancybox, event) => {
                    if (event.target.classList.contains('fancybox__backdrop') || 
                        event.target.classList.contains('fancybox__button--close') ||
                        event.target.closest('.fancybox__button--close')) {
                        window.getSelection().removeAllRanges();
                    }
                }
            }
        });
        Fancybox.bind("[data-product-mapper-fancybox]", {
            infinite: false,
            hash: false,
            type: 'inline',
            toolbar: false,
            touch: {
                vertical: false,
                momentum: false
            },
            dragToClose: false,
            autoFocus: false,
            trapFocus: false,
            on: {
                click: (fancybox, event) => {
                    if (event.target.classList.contains('fancybox__backdrop') ||
                        event.target.classList.contains('fancybox__button--close') ||
                        event.target.closest('.fancybox__button--close')) {
                        window.getSelection().removeAllRanges();
                    }
                }
            }
        });

        Fancybox.bind('[data-fancybox="video"]', {
            infinite: false,
            hash: false,
            autoFocus: false,
            trapFocus: false,
            Html: {
                video: {
                    autoplay: true,
                    controls: true,
                    preload: 'metadata'
                }
            }
        });
    }

    closeFancybox() {
        Fancybox.getInstance()?.close();
    }

    openImage(src) {
        Fancybox.show([{src: src, type: "image"}]);
    }

    closeSelectedFancybox(fancybox) {
        if (fancybox && !fancybox.isClosing()) fancybox.close();
    }

    getCurrentOpenFancybox() {
        return Fancybox.getInstance();
    }

    isFancyboxOpen() {
        let instance = Fancybox.getInstance();
        return instance ? instance.state !== 'closed' : false;
    }

    getHtmlPopupRootElement(src) {
        if (typeof src !== 'string') {
            return null;
        }

        const template = document.createElement('template');
        template.innerHTML = src.trim();

        const meaningfulNodes = Array.from(template.content.childNodes).filter((node) => {
            if (node.nodeType === Node.TEXT_NODE) {
                return node.textContent.trim() !== '';
            }

            return node.nodeType === Node.ELEMENT_NODE;
        });

        if (meaningfulNodes.length !== 1 || meaningfulNodes[0].nodeType !== Node.ELEMENT_NODE) {
            return null;
        }

        return meaningfulNodes[0];
    }

    shouldCloneHtmlPopupRoot(rootElement) {
        return rootElement.hasAttribute(fancyboxRootAttribute);
    }

    openFancybox(src, reload = null) {
        const rootElement = this.getHtmlPopupRootElement(src);
        const cloneRoot = rootElement && this.shouldCloneHtmlPopupRoot(rootElement);
        const instance = Fancybox.show([{src: cloneRoot ? rootElement : src, type: cloneRoot ? 'clone' : 'html'}]);
        if (reload) {
            const load = async () => {
                const html = await reload();
                const fresh = this.getHtmlPopupRootElement(html);
                return rootElement && fresh ? fresh.innerHTML : html;
            };
            registerPopupReload(instance.getSlide().$content, load);
        }
        return instance;
    }
}

export const fancybox = new FancyboxClass();
